import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import App from './components/app/App';
import * as serviceWorker from './serviceWorker';
import store from './state/store';
import '@progress/kendo-theme-default/dist/all.css';

axios.defaults.paramsSerializer = (p) => qs.stringify(p, { arrayFormat: 'comma' });

ReactDOM.createRoot(
  document.getElementById('root')
).render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
